/* This is the EMIS Pre material and school enviroment components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 61px; width: 800px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                height: 25px;
                width: 90px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតទាប
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតមធ្យម
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតខ្ពស់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់ចម្រុះ
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុបរួម
            </td>
          </tr>
          <!-- First row -->
          <tr style="height: 25px">
            <td style="height: 25px; width: 90px">ចំនួនថ្នាក់រៀន</td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[0].dt[0]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[0].dt[1]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[0].dt[2]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[0].dt[3]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ total }}
            </td>
          </tr>

          <!-- Second row -->
          <tr style="height: 25px">
            <td style="height: 25px; width: 90px">ចំនួនបន្ទប់រៀន</td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[1].dt[0]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[1].dt[1]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[1].dt[2]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[1].dt[3]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ total2 }}
            </td>
          </tr>

          <!-- Third row -->
          <tr style="height: 25px">
            <td style="height: 25px; width: 90px">ចំនួនគ្រូបង្រៀនតាមថ្នាក់</td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[2].dt[0]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[2].dt[1]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[2].dt[2]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[2].dt[3]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ total3 }}
            </td>
          </tr>

          <!-- 4th row -->
          <tr style="height: 25px">
            <td style="height: 25px; width: 90px">
              ចំនួនថ្នាក់រៀនអនុវត្តវិធីសាស្ត្រ រៀនតាមរយៈការលេង
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[3].dt[0]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[3].dt[1]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[3].dt[2]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput
                v-model="dmate[3].dt[3]"
                style="width: 50px; text-align: center"
              />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ total4 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["dmate", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {};
  },
  computed: {
    // need to update the total staff in json data
    total: function () {
      let result;
      let d = this.dmate[0].dt;
      result = d.reduce(function (accumulator, currentValue) {
        return accumulator + Number(currentValue);
      }, 0);
      return result;
    },
    total2: function () {
      let result;
      let d = this.dmate[1].dt;
      result = d.reduce(function (accumulator, currentValue) {
        return accumulator + Number(currentValue);
      }, 0);
      return result;
    },
    total3: function () {
      let result;
      let d = this.dmate[2].dt;
      result = d.reduce(function (accumulator, currentValue) {
        return accumulator + Number(currentValue);
      }, 0);
      return result;
    },
    total4: function () {
      let result;
      let d = this.dmate[3].dt;
      result = d.reduce(function (accumulator, currentValue) {
        return accumulator + Number(currentValue);
      }, 0);
      return result;
    },
  },
};
</script>
